{
    "AppMenu_AppsTitle": "Menu",
    "AppMenu_Apps_Reporting": "Analytique",
    "AppMenu_Apps_FastProvisioning": "Provisionnement rapide",
    "AppMenu_Apps_Administration": "Administration",
    "AppMenu_Apps_StatusAndTools": "Statut et outils",
    "AppMenu_FavouritesTitle": "Favoris",
    "NAME": "AppMenu",
    "AppMenu_NewUI": "Suite CX",
    "AppMenu_ClassicUI": "Look classique",
    "AppMenu_NewUIBadge": "Nouveau",
    "AppMenu_NewUIInvite_AriaLabel": "Essayez CX Suite",
    "AppMenu_NewUIInvite_Heading": "Découvrez CX Suite",
    "AppMenu_NewUIInvite_Body": "Une page d'accueil plus rapide, des rapports plus complets et une navigation plus claire. Essayez-la ! Vous pouvez revenir à la version précédente à tout moment.",
    "AppMenu_NewUIInvite_Confirm": "Vérifiez-le",
    "AppMenu_NewUIInvite_Dismiss": "Pas maintenant"
}